import type { MaintenanceJob, UpdateAvailability } from '../types/index.js'
import { API_BASE_URL, httpRequest } from './http.js'

export const maintenanceApi = {
  update: () => httpRequest<UpdateAvailability>('/maintenance/update', { cache: 'no-store' }),
  refreshUpdate: () => httpRequest<UpdateAvailability>('/maintenance/update/refresh', { method: 'POST' }),
  startUpdate: (body: { targetCommit: string; password: string; totp: string; acceptOnAir: boolean }) => httpRequest<MaintenanceJob>('/maintenance/update/start', { method: 'POST', body: JSON.stringify(body) }),
  createExport: (body: { passphrase: string; confirmation: string; password: string; totp: string }) => httpRequest<MaintenanceJob>('/maintenance/exports', { method: 'POST', body: JSON.stringify(body) }),
  downloadUrl: (id: string) => `${API_BASE_URL}/maintenance/exports/${id}/download`,
  deleteExport: (id: string) => httpRequest<void>(`/maintenance/exports/${id}`, { method: 'DELETE' }),
  job: (id: string) => httpRequest<MaintenanceJob>(`/maintenance/jobs/${id}`, { cache: 'no-store' }),
  cancel: (id: string) => httpRequest<MaintenanceJob>(`/maintenance/jobs/${id}/cancel`, { method: 'POST' }),
}
